import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  align-self: center;
  width: auto;
  min-width: 0;
`

export const CompanyActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-wrap: nowrap;
  width: 100%;

  button {
    height: 40px;
    min-height: 40px;
    margin: 0;
    white-space: nowrap;
  }
`

export const ActionIconButton = styled.button<{ tone?: 'primary' | 'accent' | 'danger'; isDisabled?: boolean }>`
  width: 28px;
  height: 28px;
  border: 1px solid
    ${(props) =>
      props.isDisabled
        ? '#D9E1EA'
        : props.tone === 'danger'
        ? 'rgba(228, 70, 70, 0.28)'
        : props.tone === 'accent'
        ? 'rgba(198, 1, 107, 0.22)'
        : 'rgba(45, 116, 156, 0.22)'};
  border-radius: 999px;
  background: ${(props) =>
    props.isDisabled
      ? '#F3F6F9'
      : props.tone === 'danger'
      ? 'rgba(228, 70, 70, 0.08)'
      : props.tone === 'accent'
      ? 'rgba(198, 1, 107, 0.08)'
      : 'rgba(45, 116, 156, 0.08)'};
  color: ${(props) =>
    props.isDisabled ? '#A9B6C3' : props.tone === 'danger' ? '#E44646' : props.tone === 'accent' ? '#C6016B' : '#2D749C'};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  padding: 0;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;

  &:hover {
    transform: ${(props) => (props.isDisabled ? 'none' : 'translateY(-1px)')};
    box-shadow: ${(props) => (props.isDisabled ? 'none' : '0 10px 20px rgba(45, 116, 156, 0.12)')};
  }
`

export const TextBoldViolet = styled.p<{ isDisabled?: boolean; isClicked?: boolean }>`
  font-family: 'Public Sans', sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 700;
  color: ${(props) => (props.isDisabled || props.isClicked ? '#999999' : '#C6016B')};
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  margin: 0;
  white-space: nowrap;
`

interface IRow {
  width?: string
}

export const RowContainer = styled.div<IRow>`
  width: ${(props: IRow) => props.width || 'auto'};
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 999px;
  transition: background-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: rgba(45, 116, 156, 0.08);
    transform: translateY(-1px);
  }
`

export const TextBoldBlue = styled.p<{ isItemSelected?: boolean; isDisabled?: boolean }>`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.85rem;
  color: ${(props) => (props.isDisabled ? '#A9A9A9' : '#2D749C')};
  cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  margin: 0;
  opacity: ${(props) => (props.isItemSelected ? 0.5 : 1)};
  white-space: nowrap;
`

export const DisassociateText = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.8rem;
  color: #e44646;
  cursor: pointer;
  margin: 0;
  white-space: nowrap;
`

export const DeleteText = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #e44646;
  cursor: pointer;
  margin: 0;
  white-space: nowrap;
`

export const ContainerActionItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  cursor: pointer;
  gap: 6px;
  padding: 8px 10px;
  border-radius: 999px;
  transition: background-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: rgba(198, 1, 107, 0.08);
    transform: translateY(-1px);
  }
`

interface IRow {
  width?: string
  marginLeft?: string
}

export const Row = styled.div<IRow>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0;
  width: ${(props: IRow) => props.width || 'auto'};
  max-width: 100%;
  margin: 0 auto;
`

export const DisabledBoldText = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 0.85rem;
  color: #999999;
  cursor: not-allowed;
  margin-left: 6px;
`

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 10px;
`

export const TextInterpretation = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #c6016b;
  cursor: pointer;
  margin: 0;
  white-space: nowrap;
`

export const ActionCell = styled.td`
  width: auto;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 1px;
`

export const ActionCellWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: 0;
  gap: 0;
  flex-wrap: nowrap;
`
